<template>
  <div class="item-game" :class="[number, active]">
    <template v-if="game.game === 'chimio'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-01.jpg" alt="" title=""/>
      </div>
      <h5>Chimiothérapie</h5>
    </template>
    <template v-else-if="game.game === 'myelogramme'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-02.jpg" alt="" title=""/>
      </div>
      <h5>Myelogramme</h5>
    </template>
    <template v-else-if="game.game === 'transfusion'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-03.jpg" alt="" title=""/>
      </div>
      <h5>Transfusion</h5>
    </template>
    <template v-else-if="game.game === 'decouverte'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-04.jpg" alt="" title=""/>
      </div>
      <h5>Découverte</h5>
    </template>
    <template v-else-if="game.game === 'conditionnement'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-05.jpg" alt="" title=""/>
      </div>
      <h5>Préparation à la greffe</h5>
    </template>
    <template v-else-if="game.game === 'voie-veineuse'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-06.jpg" alt="" title=""/>
      </div>
      <h5>Pôse de voie veineuse centrale</h5>
    </template>
    <template v-else-if="game.game === 'catheter'">
      <div class="cover">
        <img src="@/assets/images/content/cover-game-07.jpg" alt="" title=""/>
      </div>
      <h5>Prise de sang</h5>
    </template>
    <div class="icon">{{ number }}</div>
    <router-link :to="{ name: 'game' + game.game, params: { gameId: game.id } }" class="button btnPush" >{{ txtBt }}</router-link>
  </div>

</template>

<script>
  import Bouton from '@/components/Bouton.vue';

  export default {
    props: ['number', 'game'],
    components: { Bouton },
    data () {
      return {
        txtBt: this.game.score === 0 ? 'Jouer au jeu' : 'Rejouer',
        active: this.game.score === 0 ? 'off' : 'true'
      }
    }
  }
</script>

<style>

  .item-game {
    text-align: center;
    position: relative;
    width: 205px;
    float: left;
    margin: 0 40px;
    height: 400px;
  }
  .item-game .cover {
    width: 205px;
    height: 205px;
    border-radius: 300px;
    overflow: hidden;
    border: 5px solid #403592;
    position: relative;
  }
  .item-game .icon {
    display: inline-block;
    background: #c3c3c3;
    border: 3px solid #a28f8f;
    width: 55px;
    height: 55px;
    border-radius: 150px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding: 6px;
    font-family: 'blogger_sansbold';
    position: absolute;
    top: 170px;
    left: 50%;
    transform: translateX(-50%);
  }
  .item-game h5 {
    margin: 30px 0 10px;
  }
  .item-game .btnPush {
    margin-right: 0px;
    background: #c3c3c3;
    box-shadow: 0px 8px 0px 0px #a28f8f;
  }
  .item-game.off .btnPush {
    margin-right: 0px;
    background: #4dde45;
    box-shadow: 0px 8px 0px 0px #129a08;
  }
  .item-game.off .btnPush:hover { box-shadow: 0px 0px 0px 0px #129a08; }
  .item-game.off .icon { background: #4dde45; border-color: #129a08; }
  .item-game.off .cover { border-color: #129a08; }

  .item-game.true .btnPush {
    background: #086fab;
    box-shadow: 0px 8px 0px 0px #403592;
    margin-right: 0px;
  }
  .item-game.true .btnPush:hover { box-shadow: 0px 0px 0px 0px #403592; }
  .item-game.true .icon {
    background: #086fab;
    border: 3px solid #403592;
  }

  .item-game.true .cover::after {
    content: "\F024";
    font-family: "Font Awesome 5 Free";
    position: absolute;
    right: 0;
    top: 0;
    font-size: 60px;
    color: white;
    width: 100%;
    padding: 70px;
    height: 100%;
    display: block;
    border-radius: 100px;
    background: #086fab80;
    font-weight: 900;
  }
  .item-game.true .cover img {
    opacity: 0.5;
  }

  @media (max-width: 500px) {

    .item-game {
      float: inherit;
      clear: both;
      margin: 0 auto; }

  }

</style>
